import { useEffect } from 'react';
import { useActiveRevision } from '@pm2/course-revisions';
import { pm2SitemapStore, findPageDescriptorByPath, findCourseDescriptorFromParents } from '@pm2/sitemap-utils';
import { pm2ConfigStore } from '@pm2/store';
import { useLocation } from '@provider/navigation';
import { useUpdateLastLocationMutation } from './api/update-location.mutation.js';

function useTrackLastLocation() {
  const location = useLocation();
  const sitemapStore = pm2SitemapStore.useStore();
  const configStore = pm2ConfigStore.useStore();
  const sitemap = sitemapStore.useSelector(state => state);
  const updateLastLocationMutation = useUpdateLastLocationMutation();
  const pageDescriptor = findPageDescriptorByPath(sitemap, location.asPath);
  const activeRevision = useActiveRevision(pageDescriptor?.id);
  useEffect(() => {
    const {
      config
    } = configStore.getState();
    if (!pageDescriptor || pageDescriptor.path === config.homePath) {
      return;
    }
    switch (pageDescriptor.type) {
      case "Chapter":
        {
          const courseDescriptor = findCourseDescriptorFromParents(sitemap, pageDescriptor);
          if (!courseDescriptor) {
            return;
          }
          updateLastLocationMutation.mutate({
            type: "course",
            version: "1",
            courseId: courseDescriptor.id,
            chapterId: pageDescriptor.id,
            revisionId: activeRevision?.id
          });
          break;
        }
      case "Course":
        updateLastLocationMutation.mutate({
          type: "course",
          version: "1",
          courseId: pageDescriptor.id,
          chapterId: undefined,
          revisionId: activeRevision?.id
        });
        break;
      case "Page":
        updateLastLocationMutation.mutate({
          type: "page",
          version: "1",
          pageId: pageDescriptor.id
        });
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeRevision?.id, pageDescriptor?.id]);
}

export { useTrackLastLocation };
//# sourceMappingURL=hook.track-last-location.js.map
